import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar({ isEnglish = false }) {
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "/en";
  
  const handleScroll = (id) => (e) => {
    e.preventDefault();
    if (!isHomePage) {
      // If not on homepage, navigate to homepage with hash
      window.location.href = isEnglish ? `/en#${id}` : `/#${id}`;
      return;
    }
    
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <nav className="navbar">
      <div className="container">
        <Link to={isEnglish ? "/en" : "/"} className="navbar-brand">
          TercumanApp
        </Link>
        
        <ul className="navbar-menu">
          <li>
            <Link to={isEnglish ? "/en" : "/"}>{isEnglish ? "Home" : "Ana Sayfa"}</Link>
          </li>
          <li>
            <Link to={isEnglish ? "/en/pricing" : "/fiyatlandirma"}>
              {isEnglish ? "Pricing" : "Fiyatlandırma"}
            </Link>
          </li>
          <li>
            <a href="#features" onClick={handleScroll("features")}>{isEnglish ? "Features" : "Özellikler"}</a>
          </li>
          <li>
            <a href="#contact" onClick={handleScroll("contact")}>{isEnglish ? "Contact" : "İletişim"}</a>
          </li>
        </ul>
        
        <Link to={isEnglish ? "/" : "/en"} className="language-selector">
          {isEnglish ? "🇹🇷 Türkçe" : "🇬🇧 English"}
        </Link>
      </div>
    </nav>
  );
}
